module.exports = { "default": require("core-js/library/fn/math/sign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../node_modules/pro-gallery-items-formatter/node_modules/babel-runtime/core-js/math/sign.js
// module id = 412
// module chunks = 6 7 12 13 14 27